module.exports = __webpack_public_path__ + "static/img/nodata.00f1b5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nodata.png
// module id = UYBQ
// module chunks = 1